// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"96e25476","2733":"20e0cd67","3555":"e416f27d","4082":"b499826f","5754":"9cd0ca2e","9635":"27f0b8ca"}[chunkId] + ".chunk.css";
};